<div class="file-add-modal">
    <div class="file-header">
        <div class="f-16 f-w-600"> Field Configuration </div>
        <a href="javascript:" class="text-muted" mat-dialog-close>
            <i class="ti ti-x f-20"></i>
        </a>
    </div>
    <div class="file-body">
        <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
            <div class="col-12">
                <div class="row">
                    <div class="row">
                        <div class="col-6">
                            <label for="displayaraname" class="f-w-500">{{'arabicName' | translate}}</label>
                            <mat-form-field appearance="outline" class="w-100 m-t-5">
                                <input type="text" matInput formControlName="displayaraname"
                                    placeholder="{{'enter' | translate}} {{'arabicName' | translate}}" />
                            </mat-form-field>

                        </div>
                        <div class="col-6">
                            <label for="dislaylatname" class="f-w-500">{{'englishName' | translate}}</label>
                            <mat-form-field appearance="outline" class="w-100 m-t-5">
                                <input type="text" matInput formControlName="dislaylatname"
                                    placeholder="{{'enter' | translate}} {{'englishName' | translate}}" />
                            </mat-form-field>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <label for="minvalue" class="f-w-500">{{'minVal' | translate}}</label>
                            <mat-form-field appearance="outline" class="w-100 m-t-5">
                                <input type="number" matInput formControlName="minvalue"
                                    placeholder="{{'enter' | translate}} {{'minVal' | translate}}" />
                            </mat-form-field>

                        </div>
                        <div class="col-3">
                            <label for="maxvalue" class="f-w-500">{{'maxVal' | translate}}</label>
                            <mat-form-field appearance="outline" class="w-100 m-t-5">
                                <input type="number" matInput formControlName="maxvalue"
                                    placeholder="{{'enter' | translate}} {{'maxVal' | translate}}" />
                            </mat-form-field>

                        </div>

                        <div class="col-3">
                            <label for="precision" class="f-w-500">{{'precision' | translate}}</label>
                            <mat-form-field appearance="outline" class="w-100 m-t-5">
                                <input type="number" matInput formControlName="precision"
                                    placeholder="{{'enter' | translate}} {{'precision' | translate}}" />
                            </mat-form-field>

                        </div>
                        <div class="col-3">
                            <label for="defaultvalue" class="f-w-500">{{'defaultValue' | translate}}</label>
                            <mat-form-field appearance="outline" class="w-100 m-t-5">
                                <input type="text" matInput formControlName="defaultvalue"
                                    placeholder="{{'enter' | translate}} {{'defaultValue' | translate}}" />
                            </mat-form-field>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <label for="linkedform" class="f-w-500">{{'linkedForm' | translate}}</label>
                            <mat-form-field appearance="outline" class="w-100 m-t-5">
                                <input type="text" matInput formControlName="linkedform"
                                    placeholder="{{'enter' | translate}} {{'linkedForm' | translate}}" />
                            </mat-form-field>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <mat-checkbox class="float-start" formControlName="displaylist"
                                color="primary">{{'displayinList' | translate}}</mat-checkbox>
                        </div>
                        <div class="col-3">
                            <mat-checkbox class="float-start" formControlName="filter"
                                color="primary">{{'displayinFilter' | translate}}</mat-checkbox>
                        </div>
                        <div class="col-3">
                            <mat-checkbox class="float-start" formControlName="required" color="primary">{{'isRequired'
                                | translate}}</mat-checkbox>
                        </div>
                        <div class="col-3">
                            <mat-checkbox class="float-start" formControlName="printable"
                                color="primary">{{'isPrintable' | translate}}</mat-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <mat-checkbox class="float-start" formControlName="stopduplicate"
                                color="primary">{{'stopDuplicate' | translate}}</mat-checkbox>
                        </div>
                    </div>

                </div>
            </div>
        </form>

    </div>
    <div class="file-footer">
        <div class="text-end">
            <button mat-flat-button color="accent" class="m-r-10" mat-dialog-close>{{'cancel' | translate}}</button>
            <!-- <button mat-flat-button color="warn" class="m-r-10" (click)="clearConfig()">{{'clear' | translate}}</button> -->
            <button mat-flat-button color="primary" class="m-r-10" mat-dialog-close (click)="onSubmit()">{{'save' | translate}}</button>
        </div>
    </div>
</div>